import { render, staticRenderFns } from "./SharedLinkRestoreFile.vue?vue&type=template&id=060703df&scoped=true&"
import script from "./SharedLinkRestoreFile.vue?vue&type=script&lang=js&"
export * from "./SharedLinkRestoreFile.vue?vue&type=script&lang=js&"
import style0 from "./SharedLinkRestoreFile.vue?vue&type=style&index=0&id=060703df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060703df",
  null
  
)

export default component.exports